var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('ik-data-table',{attrs:{"model":_vm.model,"use-u-uid":true,"entity-name":"MemberRank","icon":"mdi-cash-usd"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }